export default "__VITE_ASSET__CQrnGs$F__"